module.exports = __webpack_public_path__ + "img/mediaPlus.78906814.svg";